import { apiGet } from "../Utils/axios";

export function dailySaleAPI() {
    return apiGet({ endPoint: 'dailysale' });
}

export function dailyRadialDataAPI() {
    return apiGet({ endPoint: 'targetTracker' });
}